/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {TagType} from "../../../data/aem.model";
import {Title} from "../../atoms/text/Title";
import {TextColors} from "../../../config/styles";
import {TagList} from "./TagList";
import Block from "../../atoms/layout/Block";
import {ShowHide} from "../../atoms/layout/ShowHide";
import Link from "../../atoms/text/Link";
import {ToggleIcon} from "../../atoms/bootstrap/Icons";
import {checkChildrenTags} from "../../../actions/finder";
import {connect} from "react-redux";
import {withI18N} from "../../hoc/withI18N";
import {compose} from "redux";
import {CheckboxSize} from "../../atoms/forms/Checkbox";


class CheckboxPanelSection extends React.Component {

    static propTypes = {
        title: PropTypes.string,
        tags: PropTypes.arrayOf(PropTypes.shape({
            tag: PropTypes.shape(TagType),
            unfold: PropTypes.bool,
        })),
        filterIndex: PropTypes.number.isRequired,
        selected: PropTypes.arrayOf(PropTypes.shape(TagType)),
        toggleTag: PropTypes.func
    };


    constructor(props) {
        super(props);

        this.state = { open: -1 };

        this.toggleList = this.toggleList.bind(this);
        this.selectAll = this.selectAll.bind(this);
    }

    toggleList = (index) => {
        this.setState({ open: this.state.open === index ? -1 : index });
    };

    selectAll = (tag) => () => this.props.checkChildrenTags({
        filterIndex: this.props.filterIndex,
        tag
    });

    renderSubsection = (subsection, index) => {
        const open = this.state.open === index;

        const allTagSelected = subsection.tag.children.findIndex(subsectionTag => this.props.selected.findIndex(tag => tag.id === subsectionTag.id) === -1) === -1;

        return (
            <Block key={subsection.tag.id} className="p-filter-container__aside-panel__subsection">
                <Block className={"p-flex p-filter-container__aside-panel__subsection-header" + (open || subsection.unfold ? " open" : "")}>
                    <span className={"text-small" + (!subsection.unfold ? " expandable" : "")} onClick={() => this.toggleList(index)}>{subsection.tag.title}</span>
                    <div className={"p-flex p-flex-align-baseline"}>
                        <ShowHide show={(open || subsection.unfold) && !allTagSelected}>
                            <span className="link__select-all" onClick={this.selectAll(subsection.tag.id)}>
                                {this.props.translate("Select All")}
                            </span>
                        </ShowHide>
                        {!subsection.unfold &&
                        <span className={`svg-arrow-${open ? "up" : "down"}-xs p-margin-left-sm p-cursor-pointer`} onClick={() => this.toggleList(index)}/>}
                    </div>
                </Block>
                <ShowHide show={open || subsection.unfold}>
                    <Block className="p-filter-container__aside-panel__subsection-body">
                        <TagList tags={subsection.tag.children || []} selected={this.props.selected}
                                 size={CheckboxSize.sm} onTagSelect={this.props.toggleTag} />
                    </Block>
                </ShowHide>
            </Block>
        );
    };

    render() {
        if (this.props.tags.length === 0) {
            return null;
        }

        return (<Block className="p-filter-container__aside-panel__section">
            { this.props.title && <Block className="p-filter-container__aside-panel__section-header">
                <span className="text-medium-semi-bold">{this.props.title}</span>
            </Block>}

            <Block className="p-filter-container__aside-panel__section-body">
                {this.props.tags.map(this.renderSubsection)}
            </Block>
        </Block>)
    }
}


export default compose(connect(undefined, {
    checkChildrenTags
}), withI18N)(CheckboxPanelSection);
